export const LOGO_URL="https://freepngimg.com/save/152795-food-burger-junk-hq-image-free/512x512";

export const CDN_URL="https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const RES_URL="https://corsproxy.org/?"+encodeURIComponent("https://www.swiggy.com/dapi/restaurants/list/v5?lat=28.7108654&lng=77.20314929999999&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING")
//https://www.swiggy.com/dapi/restaurants/list/v5?lat=28.7040592&lng=77.10249019999999&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING

export const PIZZA_IMG_URL="https://img.freepik.com/free-photo/top-view-pepperoni-pizza-with-mushroom-sausages-bell-pepper-olive-corn-black-wooden_141793-2158.jpg?w=2000";

export const NORTH_IMG_URL="https://upload.wikimedia.org/wikipedia/commons/9/9e/Chole_Bhature_from_Nagpur.JPG";

export const CHINESE_IMG_URL="https://images.unsplash.com/photo-1585032226651-759b368d7246?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8Y2hpbmVzZSUyMGZvb2R8ZW58MHx8MHx8fDA%3D&w=1000&q=80";

export const IceCreams_IMG_URL="https://cdn.britannica.com/50/80550-050-5D392AC7/Scoops-kinds-ice-cream.jpg";

export const HEALTHY_IMG_URL="https://www.morelandobgyn.com/hubfs/Imported_Blog_Media/GettyImages-854725402-1.jpg";

export const RESTAURANT_MENU_API_URL="https://corsproxy.org/?"+encodeURIComponent("https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9351929&lng=77.62448069999999&restaurantId=");

export const NAV_IMG_URL="https://cdn-icons-png.flaticon.com/128/5107/5107718.png";

export const NAV_CROSS_IMG_URL="https://cdn-icons-png.flaticon.com/128/1617/1617543.png";

export const ENGINNER_IMG_URL="https://cdn-icons-png.flaticon.com/128/2705/2705118.png";

export const COMPANY_IMG_URL="https://cdn-icons-png.flaticon.com/128/4300/4300059.png";

export const PHONE_IMG_URL="https://cdn-icons-png.flaticon.com/128/3437/3437364.png";

export const LOCATION_IMG_URL="https://cdn-icons-png.flaticon.com/128/11510/11510528.png";

export const GITHUB_IMG_URL="https://cdn-icons-png.flaticon.com/128/3291/3291695.png";

export const LINKEDIN_IMG_URL="https://cdn-icons-png.flaticon.com/128/3536/3536505.png";

export const INSTAGRAM_IMG_URL="https://cdn-icons-png.flaticon.com/128/10856/10856864.png";

export const GMAIL_IMG_URL="https://cdn-icons-png.flaticon.com/128/732/732200.png";

export const ITEM_IMG_URL="https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/";